import { Capacitor, registerPlugin } from '@capacitor/core';

var GeocoderNative = null;

function _isNativeApp() {
  try {
    return Capacitor.isNativePlatform();
  } catch (e) {
    return false;
  }
}

function _getPlugin() {
  if (!GeocoderNative) {
    GeocoderNative = registerPlugin('Geocoder');
  }
  return GeocoderNative;
}

/**
 * Apple CLGeocoder wrapper via Capacitor plugin.
 * Falls back gracefully on web (non-native) — returns null.
 */
export var VcGeocoder = {

  /**
   * Reverse geocode lat/lon → display name + structured address.
   * @param {number} latitude
   * @param {number} longitude
   * @returns {Promise<{displayName, latitude, longitude, city?, state?, country?, countryCode?, postalCode?} | null>}
   */
  reverseGeocode: function (latitude, longitude) {
    if (!_isNativeApp()) return Promise.resolve(null);
    return _getPlugin().reverseGeocode({ latitude: latitude, longitude: longitude })
      .catch(function (err) {
        console.warn('Geocoder.reverseGeocode failed:', err);
        return null;
      });
  },

  /**
   * Forward geocode an address string → lat/lon + display name.
   * @param {string} address
   * @returns {Promise<{displayName, latitude, longitude, city?, state?, country?, countryCode?, postalCode?} | null>}
   */
  forwardGeocode: function (address) {
    if (!_isNativeApp()) return Promise.resolve(null);
    return _getPlugin().forwardGeocode({ address: address })
      .catch(function (err) {
        console.warn('Geocoder.forwardGeocode failed:', err);
        return null;
      });
  }
};
